import React, { useState, useContext } from "react";
import classNames from "classnames";
import Input from "./parts/Input";
import Select from "../components/Select";
import Controls from "./parts/Controls";
import List from "./parts/List";
import { useSelector } from "react-redux";
import { removeDecimal } from "../apis/utils";
import coinLogos from "../assets/images/currency-icons/coinLogos.js";
import { BigNumber, ethers } from "ethers";
import { Web3Context } from "../contexts/Web3Context";
import CrossCloseButton from "./parts/CrossCloseButton";
import { useDispatch } from "react-redux";
import InfoButton from "../partials/Form/InfoButton";
import InfoButtonMobile from "../partials/Form/InfoButtonMobile";

const riskList = [
  { id: 0, value: "Low" },
  { id: 1, value: "High" },
];

export default function () {
  const Swal = require("sweetalert2");
  let web3Context = useContext(Web3Context);
  const asset = useSelector((state) => state.modal.data.asset);
  const [page, setPage] = useState("supply");
  const [max, setMax] = useState(0);
  const [formData, setFormData] = useState({
    value: 0,
    risk: riskList[0],
  });
  const [supplying, setSupplying] = useState(false);
  const [approving, setApproving] = useState(false);
  const [withdrawing, setWithdrawing] = useState(false);

  const changeHandler = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleApprove = async (e) => {
    e.preventDefault();
    try {
      setApproving(true);
      const approveTx = await asset.contract.approve(
        asset.mmi.address,
        ethers.constants.MaxUint256
      );
      await approveTx.wait();
    } catch (error) {
      setApproving(false);
      return;
    }
    Swal.fire({
      title: "Approve Successful.",
      icon: "info",
      confirmButtonText: '<a href="/trade">OK</a>',
    });
    setApproving(false);
    /*    window.location.reload(); */
    return;
  };

  const handleSupply = async (e) => {
    e.preventDefault();
    const accountBalance = asset.balance;
    const requestedSupply =
      formData.value === ""
        ? ethers.utils.parseEther("0")
        : asset.contract.address != "0xAC51066d7bEC65Dc4589368da368b212745d63E8"
        ? asset.contract.address !=
            "0xEB4C2781e4ebA804CE9a9803C67d0893436bB27D" &&
          asset.contract.address != "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599"
          ? ethers.utils.parseEther(formData.value.toString())
          : ethers.utils.parseUnits(formData.value.toString(), 8)
        : ethers.utils.parseUnits(formData.value.toString(), 6);
    // edge cases
    if (web3Context.currentAccountAddress == "") {
      Swal.fire({
        title: "You are not connected. Connect and try again.",
        icon: "info",
        confirmButtonText: "OK",
      });
      return;
      return;
    }
    // must have enough balance
    if (accountBalance.lt(requestedSupply)) {
      Swal.fire({
        title: "Insufficient balance.",
        icon: "info",
        confirmButtonText: "OK",
      });

      return;
    }

    try {
      setSupplying(true);
      if (formData.risk.id == 0) {
        const lendLRTx = await asset.mmi.lendToALRpool(requestedSupply);
        await lendLRTx.wait();
      } else {
        const lendHRTx = await asset.mmi.lendToAHRpool(requestedSupply);
        await lendHRTx.wait();
      }
    } catch (error) {
      setSupplying(false);
      return;
    }
    Swal.fire({
      title: "Supply Successful.",
      icon: "info",
      confirmButtonText: '<a href="/trade">OK</a>',
    });
    setSupplying(false);
  };

  const handleWithdraw = async (e) => {
    e.preventDefault();
    const requestedWithdraw =
      formData.value === ""
        ? ethers.utils.parseEther("0")
        : asset.contract.address == "0xAC51066d7bEC65Dc4589368da368b212745d63E8"
        ? ethers.utils.parseUnits(formData.value.toString(), 6)
        : ethers.utils.parseEther(formData.value.toString());

    // edge cases
    if (web3Context.currentAccountAddress == "") {
      Swal.fire({
        title: "You are not connected. Connect and try again.",
        icon: "info",
        confirmButtonText: "OK",
      });

      return;
    }
    // must have enough balance
    if (
      (formData.risk.id == 0
        ? asset.alrBalanceInAsset
        : asset.ahrBalanceInAsset
      ).lt(requestedWithdraw)
    ) {
      Swal.fire({
        title: "Withdrawal is larger than protocol balance.",
        icon: "info",
        confirmButtonText: "OK",
      });

      return;
    }

    // liquidity check
    if (formData.risk.id == 0) {
      if (asset.liquidityLR.lt(requestedWithdraw)) {
        Swal.fire({
          title: "Not enough liquidity to withdraw funds.",
          icon: "info",
          confirmButtonText: "OK",
        });

        return;
      }
    } else {
      if (asset.liquidityHR.lt(requestedWithdraw)) {
        Swal.fire({
          title: "Not enough liquidity to withdraw funds.",
          icon: "info",
          confirmButtonText: "OK",
        });
        return;
      }
    }

    try {
      setWithdrawing(true);
      if (formData.risk.id == 0) {
        let withdrawLRTx = await asset.alr.redeem(requestedWithdraw);
        await withdrawLRTx.wait();
      } else {
        let withdrawHRTx = await asset.ahr.redeem(requestedWithdraw);
        await withdrawHRTx.wait();
      }
    } catch (error) {
      console.log(error);
      setWithdrawing(false);
      return;
    }
    Swal.fire({
      title: "Withdraw Successful.",
      icon: "info",
      confirmButtonText: '<a href="/trade">OK</a>',
    });
    setWithdrawing(false);
  };

  return (
    <div className="modal modal_trade modal_w550">
      <CrossCloseButton className="custom-cross-btn_black close_btn" />
      <header className="modal-header">
        <div className="modal-header__currency">
          <img src={coinLogos[asset.index]} alt="icon" />
          <span>{asset.name}</span>
        </div>
        <div className="modal-header__controls">
          <button
            className={classNames("custom-gradient-btn", {
              active: page === "supply",
            })}
            onClick={() => setPage("supply")}
          >
            <span>Supply</span>
          </button>
          <InfoButton marginBottom={10} textAlign="left" posX="left">
            Lend your assets and receive Risk Tokens.
          </InfoButton>
          <InfoButtonMobile text="Lend your assets and receive Risk Tokens." />
          <button
            className={classNames("custom-gradient-btn", {
              active: page === "withdraw",
            })}
            onClick={() => setPage("withdraw")}
          >
            <span>Withdraw</span>
          </button>
          <InfoButton marginBottom={10} textAlign="left" posX="left">
            Burn LR and HR Tokens to unlock collateral.
          </InfoButton>
          <InfoButtonMobile text="Burn LR and HR Tokens to unlock collateral." />
        </div>
      </header>

      <form className="modal-lend-form">
        <div className="modal-form__item">
          <div className="modal-form__col">
            <p className="modal-form__suptext">
              I Want to {page === "supply" ? "Supply" : "Withdraw"}
            </p>
            <div className="modal-form__field">
              <Input
                name="value"
                type="float"
                placeholder="Your sum..."
                value={formData.value}
                onChange={changeHandler}
                maxEnable
                maxHandler={() =>
                  setFormData({
                    ...formData,
                    value:
                      page === "supply"
                        ? asset.contract.address !=
                          "0xAC51066d7bEC65Dc4589368da368b212745d63E8"
                          ? asset.contract.address !=
                              "0xEB4C2781e4ebA804CE9a9803C67d0893436bB27D" &&
                            asset.contract.address !=
                              "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599"
                            ? ethers.utils.formatEther(asset.balance)
                            : ethers.utils.formatUnits(asset.balance, 10)
                          : ethers.utils.formatUnits(asset.balance, 6)
                        : formData.risk.id == 0
                        ? asset.contract.address !=
                          "0xAC51066d7bEC65Dc4589368da368b212745d63E8"
                          ? asset.contract.address !=
                              "0xEB4C2781e4ebA804CE9a9803C67d0893436bB27D" &&
                            asset.contract.address !=
                              "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599"
                            ? ethers.utils.formatEther(asset.alrBalanceInAsset)
                            : ethers.utils.formatUnits(
                                asset.alrBalanceInAsset,
                                8
                              )
                          : ethers.utils.formatUnits(asset.alrBalanceInAsset, 6)
                        : asset.contract.address !=
                          "0xAC51066d7bEC65Dc4589368da368b212745d63E8"
                        ? asset.contract.address !=
                            "0xEB4C2781e4ebA804CE9a9803C67d0893436bB27D" &&
                          asset.contract.address !=
                            "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599"
                          ? ethers.utils.formatEther(asset.ahrBalanceInAsset)
                          : ethers.utils.formatUnits(asset.ahrBalanceInAsset, 8)
                        : ethers.utils.formatUnits(asset.ahrBalanceInAsset, 6),
                  })
                }
              />
              <div className="modal-form__curr">{asset.name}</div>
            </div>
            <p className="modal-form__subtext">
              {page === "supply"
                ? "Wallet Balance: " +
                  (asset.contract.address !=
                  "0xAC51066d7bEC65Dc4589368da368b212745d63E8"
                    ? asset.contract.address !=
                        "0xEB4C2781e4ebA804CE9a9803C67d0893436bB27D" &&
                      asset.contract.address !=
                        "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599"
                      ? removeDecimal(
                          ethers.utils.formatEther(asset.balance) * 1000
                        ) / (1000).toString()
                      : ethers.utils.formatEther(asset.balance) *
                        (10000000000).toString()
                    : removeDecimal(
                        ethers.utils.formatUnits(asset.balance, 6) * 1000
                      ) / (1000).toString()) +
                  " " +
                  asset.name
                : formData.risk.id == 0
                ? "LR Market Balance: " +
                  (asset.contract.address !=
                  "0xAC51066d7bEC65Dc4589368da368b212745d63E8"
                    ? asset.contract.address !=
                        "0xEB4C2781e4ebA804CE9a9803C67d0893436bB27D" &&
                      asset.contract.address !=
                        "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599"
                      ? removeDecimal(
                          ethers.utils.formatEther(asset.alrBalanceInAsset) *
                            1000
                        ) / (1000).toString()
                      : ethers.utils
                          .formatUnits(asset.alrBalanceInAsset, 8)
                          .toString()
                    : removeDecimal(
                        ethers.utils.formatUnits(asset.alrBalanceInAsset, 6) *
                          1000
                      ) / (1000).toString()) +
                  " " +
                  asset.name
                : "HR Market Balance: " +
                  (asset.contract.address !=
                  "0xAC51066d7bEC65Dc4589368da368b212745d63E8"
                    ? asset.contract.address !=
                        "0xEB4C2781e4ebA804CE9a9803C67d0893436bB27D" &&
                      asset.contract.address !=
                        "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599"
                      ? removeDecimal(
                          ethers.utils.formatEther(asset.ahrBalanceInAsset) *
                            1000
                        ) / (1000).toString()
                      : ethers.utils
                          .formatUnits(asset.ahrBalanceInAsset, 8)
                          .toString()
                    : removeDecimal(
                        ethers.utils.formatUnits(asset.ahrBalanceInAsset, 6) *
                          1000
                      ) / (1000).toString()) +
                  " " +
                  asset.name}
            </p>
          </div>
          <div className="modal-form__col modal-form__col_w140">
            <p className="modal-form__suptext" style={{ display: "flex" }}>
              {page === "supply" ? (
                <>
                  Risk &nbsp;
                  <InfoButton marginBottom={10} textAlign="left" posX="left">
                    High risk is subject to liquidation first, low risk is
                    protected by high risk and very rarely subject to
                    liquidation.
                  </InfoButton>{" "}
                  <InfoButtonMobile text=" High risk is subject to liquidation first, low risk is protected by high risk and very rarely subject to liquidation." />
                </>
              ) : (
                "From Risk Market"
              )}
            </p>
            <div className="modal-form__field">
              <Select
                className="modal__select"
                current={formData.risk.value}
                setValue={changeHandler}
                name="risk"
              >
                {riskList.map((item) => (
                  <Select.Item key={item.id} item={item} />
                ))}
              </Select>
            </div>
            <p className="modal-form__subtext">
              APR:{" "}
              {formData.risk.id == 0
                ? removeDecimal(
                    ethers.utils.formatEther(asset.supplyApyAlr) * 100
                  ) / (100).toString()
                : removeDecimal(
                    ethers.utils.formatEther(asset.supplyApyAhr) * 100
                  ) / (100).toString()}
              %
            </p>
          </div>
        </div>

        <button
          className="button-b button-b_sm modal-controls__btn"
          style={{ margin: "10px auto 0" }}
          onClick={
            page === "supply"
              ? asset.allowance > ethers.utils.parseEther("10000")
                ? handleSupply
                : handleApprove
              : handleWithdraw
          }
          disabled={supplying || approving || withdrawing}
        >
          {page === "supply"
            ? asset.allowance > ethers.utils.parseEther("100")
              ? supplying
                ? "Supplying..."
                : "Supply"
              : approving
              ? "Approving..."
              : "Approve"
            : withdrawing
            ? "Withdrawing"
            : "Withdraw"}
        </button>
      </form>
    </div>
  );
}
